// extracted by css-extract-rspack-plugin
export default {"link":"_d1d8bd7e","title":"_21acedbe"};